<div class="page-content">
  <h1 class="page-title">Audit Logs</h1>
  <p class="page-subtitle">View all audit logs for user activities</p>

  <app-table
    [data]="auditState.audits()"
    [columns]="auditColumns"
    [config]="auditConfig"
    [pagination]="auditPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (searchChange)="onSearchChange($event)"
    (dateRangeChange)="onDateRangeChange($event)"></app-table>
</div>
